import { connect } from 'react-redux';
import PlanScheduleList from './PlanScheduleList';
import { bindActionCreators } from 'redux';
import {planListing} from "../../../services/redux/brandActivtion/sitesListing/action";
import {fetchZones, getListFilterData} from "../../../services/redux/sales/preSaleListing/action";

const mapStateToProps = state => ({
    planListingData: state.baSiteListingReducer.planListingData,
    getFetchZones: state.preSalesListReducer.getFetchZones,
    filterDropdownList: state.preSalesListReducer.filterDropdownList,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    planListing,
    getListFilterData,
    fetchZones
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(PlanScheduleList);
